import React from 'react';
import * as S from './styles';

const InputText = React.forwardRef(
  (
    {
      form = undefined,
      name,
      type,
      // value,
      required = false,
      placeholder,
      minLength,
      maxLength,
      label,
      error,
      readonly = false,
      onChange,
      disabled = false,
      styleContainer,
      ...rest
    },
    ref,
  ) => {
    return (
      <S.InputText disabled={disabled} readOnly={readonly} style={styleContainer}>
        {label && <S.Label htmlFor={name}>{label}</S.Label>}

        <S.InputContainer>
          <S.Input
            ref={ref}
            form={form}
            id={name}
            name={name}
            type={type}
            // value={value ?? ''}
            required={required}
            onChange={onChange}
            minLength={minLength}
            maxLength={maxLength}
            min={minLength}
            max={maxLength}
            step={0.1}
            readOnly={readonly}
            placeholder={placeholder}
            disabled={disabled}
            {...rest}
          />
          {error && <S.Error>{error}</S.Error>}
        </S.InputContainer>
      </S.InputText>
    );
  },
);

InputText.displayName = 'InputText';

export default InputText;
